import React, { useEffect } from "react";

// App routes
import Routes from "routes";

// API handle
import withAxiosWrapper from "shared/axios/withAxiosWrapper";

// Material UI
import { ThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import Green from "@material-ui/core/colors/green";
import Red from "@material-ui/core/colors/red";
import { getThemeByDomain, applyTheme } from "utils/domainThemes";
import Colors from "shared/color";

//css for sidebar
import './App.css';

let App = () => {
  // Get theme colors from domain
  const themeColors = getThemeByDomain().colors;
  
  // Apply theme when component mounts
  useEffect(() => {
    applyTheme();
  }, []);

  // Create MUI theme with our custom theme configuration
  const theme = createMuiTheme({
    palette: {
      primary: {
        main: themeColors.primary,
        light: themeColors.primary,
        dark: themeColors.primary,
        buttonprimary: themeColors.buttonprimary || themeColors.primary,
      },
      secondary: {
        main: themeColors.secondary,
        light: themeColors.secondary,
        dark: themeColors.secondary,
      },
      background: {
        default: themeColors.background,
      },
      success: {
        light: Green[300],
        main: Green[500],
        dark: Green[700],
      },
      error: {
        light: Red[300],
        main: Red[500],
        dark: Red[700],
      },
      type: "light",
    },
    typography: {
      color: "#fff",
      button: {
        textTransform: "capitalize",
        fontFamily: "poppins-semibold",
        fontSize: "0.8125rem",
      },

      fontFamily: "poppins-medium",
      // fontSize:"0.8125rem",
      // color:"red"
    },
    overrides: {
      MuiPaper: {
        elevation1: {
          boxShadow: `0px 3px 6px ${Colors["LightPurpleShadow"]}`,
        },
        rounded: {
          borderRadius: "5px",
        },
      },
      MuiCardContent: {
        root: {
          padding: "1.2rem",
        },
      },
      MuiDivider: {
        root: {
          backgroundColor: Colors["purlple_100"],
        },
      },
      MuiButton: {
        contained: {
          // height:"40px",
          boxShadow: "none",
        },
      },
      MuiTableContainer: {
        root: {
          overflowX: "none",
        },
      },
      MuiTypography: {
        root: {
          // fontSize: "0.8125rem",
          textTransform: "capitalize",
        }
      },

      // MuiCssBaseline: {
      //   '@global': {
      //     '@font-face': ["poppins-medium"],
      //   },
      // },
    },
  });

  const setDocumentTitle = () => {
    const theme = getThemeByDomain();
    const envMode = process.env.REACT_APP_STATUS;
    
    const brandName = theme.brandName || "Tradofina";
    
    if (envMode === "Test") {
      document.title = `Test ${brandName} | Admin Panel`;
    }
    else {
      document.title = `${brandName} | Admin Panel`;
    }
  };

  const setFavicon = () => {
    const theme = getThemeByDomain();
    const faviconHref = theme.favicon || "/favicon.svg"; 

    let link = document.querySelector("link[rel~='icon']");

    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }

    link.href = faviconHref;
  };

  useEffect(() => {
    setDocumentTitle();
    setFavicon();
  }, []); 

  return (
    <ThemeProvider theme={theme}>
      <Routes />
    </ThemeProvider>
  );
};

App = withAxiosWrapper(App);

export default App;
